import axios from "axios";
import { base } from "../base";

// Gated partner brochure download. Same public form endpoint
// as the partnerships enquiry, tagged with its own source + attribution.
export const submitBrochureLead = async ({ fullName, email, companyName, assesmentPerMonth, marketingConsent, utm, landingPage }) => {
  const response = await axios.post(`${base}/api/public/form`, {
    source: "brochure_partner_portal",
    fullName,
    email,
    companyName,
    assesmentPerMonth,
    marketingConsent: marketingConsent === true,
    utm,
    landingPage,
  });
  return response.data;
};
